export class ErrorState {
  constructor(readonly message: string) {}
}
